import React from "react";
import ReactDOM from "react-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ThemeProvider from "../../_globalStore/themeProvider/ThemeProvider";
import { Provider } from "react-redux";
import { setupStore } from "../../_globalStore/redux/store";
import CssBaseline from "@mui/material/CssBaseline";

export const generatePDFReport = async (contentToExport: React.JSX.Element): Promise<jsPDF | null> => {
  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.transform = "translate(-9999px, -9999px)";
  container.style.width = "1000px";

  const contentWrappedByTheme = (
    <Provider store={setupStore()}>
      <ThemeProvider>
        <CssBaseline>{contentToExport}</CssBaseline>
      </ThemeProvider>
    </Provider>
  );

  ReactDOM.render(contentWrappedByTheme, container);
  if (container) {
    document.body.appendChild(container);

    let pdf = new jsPDF("p", "mm", "a4");

    if (container.scrollHeight > 1400) {
      const pagesTotalNumber = Math.ceil(container.scrollHeight / 1400);
      let pages: string[] = [];

      const captureImg = async (pageNumber: number) => {
        return html2canvas(container, {
          scale: 2,
          height: 1400,
          y: pageNumber * 1400,
        }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          return imgData;
        });
      };

      for (let i = 0; i < pagesTotalNumber; i++) {
        const imgData = await captureImg(i);
        pages.push(imgData);
      }

      pages.forEach((page, idx) => {
        if (idx > 0) {
          pdf.addPage();
        }
        pdf.addImage(page, "PNG", 5, 5, 200, 287);
      });
      return pdf;
    } else {
      return html2canvas(container, {
        scale: 2,
        height: 1400,
        y: 0,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        pdf.addImage(imgData, "PNG", 5, 5, 200, 287);
        return pdf;
      });
    }
  }
  return null;
};

export const exportReport = async (
  contentToExport: React.JSX.Element,
  setLoading: (loading: boolean) => void,
  customNameToSave: string
) => {
  setLoading(true);

  try {
    const file = await generatePDFReport(contentToExport);
    if (file) {
      file.save(`${customNameToSave}`);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};
